// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"d015354e","99":"5458a0d6","127":"16191562","155":"b8fbe394","204":"9b116b7b","361":"4c213463","418":"a1e4abfe","508":"87a45abb","615":"b5720842","638":"97635530","990":"a6094010"}[chunkId] + ".chunk.js";
};